import {Dropdown} from '@/components/atoms'
import './DropdownControl.scss'
const DropdownControl = props => {
  /**
   * @typedef {Object} Props
   * @property {function} handleChange - Function to handle changes in the dropdown.
   * @property {string} label - Label for the dropdown control.
   * @property {string} path - Path for the dropdown control.
   * @property {Object} errors - Object containing validation errors.
   * @property {Object} schema - Schema for the dropdown control.
   * @property {Object} uischema - UI schema for the dropdown control.
   * @property {boolean} required - Indicates if the dropdown is required.
   */
  const {handleChange, label, path, errors, schema, uischema, required, data} = props
  const dropdownChange = newVal => {
    handleChange(path, newVal?.[0]?.displayText ?? '')
    handleChange(path + 'Value', newVal?.[0]?.value ?? '')
  }
  return (
    <Dropdown
      label={label}
      updateValue={dropdownChange}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
      value={data ? [{id: data, displayText: data}] : []}
    />
  )
}

export default DropdownControl
